import { atom } from 'jotai';
import type { ViewState } from '../model/viewPlan';
import { EMPTY_FIELD, type WindField } from '../model/windField';
import type { WindBlock, WindIndex } from '../tiles/format';

// Read these freely; change them through the action atoms in ./actions.ts.

/** The wind API's latest runs and when they were fetched (ms since the epoch). */
export const windIndexAtom = atom<{ index: WindIndex; fetched: number } | null>(null);

/** Blocks loaded recently, by their path in the wind API (see blockPath). */
export const blocksAtom = atom<ReadonlyMap<string, WindBlock>>(new Map());

/** The area the wind is loaded for, set as the map moves. */
export const viewAtom = atom<ViewState | null>(null);

/** Time the forecast is shown for, ms since the epoch; null follows the current time. */
export const forecastTimeAtom = atom<number | null>(null);

/** The current time, ms; ticks while the forecast is shown so "now" moves along. */
export const clockAtom = atom(Date.now());

export type LoadStatus = { kind: 'idle' } | { kind: 'error'; error: unknown };

export const loadStatusAtom = atom<LoadStatus>({ kind: 'idle' });

/**
 * What the map draws, for the view at the shown time. Blocks still loading keep the values shown before (see
 * assembleLayer), so it fills in as data arrives rather than waiting for all of it.
 */
export const windFieldAtom = atom<WindField>(EMPTY_FIELD);
